import { FC } from "react";

import IconProps from "./IconProps";

const ChevronRightThin: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17206_363)">
      <path
        d="M7.5 5.5L12.5 10.5L7.5 15.5"
        stroke="#627293"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17206_363">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default ChevronRightThin;
